(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function parseProduct(card) {
    var script = card.querySelector('[data-aspyr-bundle-product-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (error) { return null; }
  }

  function selectedOptions(card) {
    return Array.prototype.map.call(card.querySelectorAll('[data-option-index]'), function (group) {
      var selected = group.querySelector('[data-option-value].is-selected');
      return selected ? selected.dataset.optionValue : '';
    });
  }

  function matchingVariant(product, options) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, index) { return value === options[index]; });
    }) || null;
  }

  function optionCanResolve(product, selected, optionIndex, value) {
    return product.variants.some(function (variant) {
      if (!variant.available || variant.options[optionIndex] !== value) return false;
      return variant.options.every(function (variantValue, index) {
        return index === optionIndex || !selected[index] || selected[index] === variantValue;
      });
    });
  }

  function setImage(card, variant, product) {
    var image = card.querySelector('[data-aspyr-bundle-image]');
    if (!image) return;
    var source = variant && variant.featured_image && variant.featured_image.src;
    if (!source && product.featured_image) source = product.featured_image;
    if (!source) return;
    image.src = source.indexOf('?') > -1 ? source + '&width=700' : source + '?width=700';
    image.removeAttribute('srcset');
  }

  function updateCard(card) {
    var product = card._aspyrProduct || (card._aspyrProduct = parseProduct(card));
    if (!product) return null;
    var selected = selectedOptions(card);
    var variant = matchingVariant(product, selected);
    var available = !!(variant && variant.available);

    card.dataset.variantId = variant ? variant.id : '';
    card.dataset.price = variant ? variant.price : 0;
    card.dataset.available = available ? 'true' : 'false';

    var price = card.querySelector('[data-aspyr-bundle-item-price]');
    var status = card.querySelector('[data-aspyr-bundle-item-status]');
    if (price && variant) price.textContent = formatMoney(variant.price);
    if (status) {
      status.textContent = available ? 'In stock' : 'Sold Out';
      status.classList.toggle('is-unavailable', !available);
    }
    if (variant) setImage(card, variant, product);

    Array.prototype.forEach.call(card.querySelectorAll('[data-option-index]'), function (group) {
      var optionIndex = Number(group.dataset.optionIndex);
      Array.prototype.forEach.call(group.querySelectorAll('[data-option-value]'), function (button) {
        button.classList.toggle('is-unavailable', !optionCanResolve(product, selected, optionIndex, button.dataset.optionValue));
      });
    });
    return variant;
  }

  function bundleState(bundle) {
    var cards = Array.prototype.slice.call(bundle.querySelectorAll('[data-aspyr-bundle-product]'));
    var variants = cards.map(updateCard);
    var available = variants.length > 0 && variants.every(function (variant) { return variant && variant.available; });
    var original = variants.reduce(function (sum, variant) { return sum + (variant ? Number(variant.price) : 0); }, 0);
    var discount = Math.max(0, Math.min(100, Number(bundle.dataset.discountPercent || 0)));
    var total = Math.round(original * (100 - discount) / 100);
    return { cards: cards, variants: variants, available: available, original: original, total: total, saved: original - total };
  }

  function updateBundle(bundle) {
    var state = bundleState(bundle);
    var compare = bundle.querySelector('[data-aspyr-bundle-compare]');
    var total = bundle.querySelector('[data-aspyr-bundle-total]');
    var saved = bundle.querySelector('[data-aspyr-bundle-saved]');
    var buttonPrice = bundle.querySelector('[data-aspyr-bundle-button-price]');
    var button = bundle.querySelector('[data-aspyr-bundle-add]');
    var status = bundle.querySelector('[data-aspyr-bundle-status]');

    if (compare) {
      compare.textContent = state.saved > 0 ? formatMoney(state.original) : '';
      compare.hidden = state.saved <= 0;
    }
    if (total) total.textContent = formatMoney(state.total);
    if (saved) {
      var label = bundle.dataset.discountLabel || 'Save';
      saved.textContent = state.saved > 0 ? label + ' ' + formatMoney(state.saved) : '';
      saved.hidden = state.saved <= 0;
    }
    if (buttonPrice) buttonPrice.textContent = formatMoney(state.total);
    if (button) button.disabled = !state.available;
    if (status) {
      status.innerHTML = state.available
        ? '<span aria-hidden="true"></span> In stock · Ready to ship'
        : '<span aria-hidden="true"></span> Select available options';
      status.classList.toggle('is-unavailable', !state.available);
    }
    bundle._aspyrState = state;
  }

  function showError(bundle, message) {
    var error = bundle.querySelector('[data-aspyr-bundle-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function addBundle(bundle) {
    updateBundle(bundle);
    var state = bundle._aspyrState;
    var button = bundle.querySelector('[data-aspyr-bundle-add]');
    var label = bundle.querySelector('[data-aspyr-bundle-button-label]');
    if (!state || !state.available || button.disabled) return;

    showError(bundle, '');
    button.disabled = true;
    button.classList.add('is-loading');
    var originalLabel = label.textContent;
    label.textContent = 'Adding bundle';

    var items = state.variants.map(function (variant, index) {
      return {
        id: Number(variant.id),
        quantity: 1,
        properties: {
          '_aspyr_bundle_id': bundle.dataset.bundleId,
          '_aspyr_bundle_name': bundle.dataset.bundleName,
          '_aspyr_bundle_component': String(index + 1)
        }
      };
    });

    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (error) { throw error; });
        return response.json();
      })
      .then(function (added) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added } }));
      })
      .catch(function (error) {
        showError(bundle, error.description || error.message || 'This bundle could not be added. Please check the selected options.');
      })
      .finally(function () {
        button.classList.remove('is-loading');
        label.textContent = originalLabel;
        updateBundle(bundle);
      });
  }

  function initBundle(bundle) {
    if (bundle.dataset.aspyrBundleReady === 'true') return;
    bundle.dataset.aspyrBundleReady = 'true';
    bundle.addEventListener('click', function (event) {
      var option = event.target.closest('[data-option-value]');
      if (option && bundle.contains(option)) {
        var group = option.closest('[data-option-index]');
        Array.prototype.forEach.call(group.querySelectorAll('[data-option-value]'), function (button) {
          var selected = button === option;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        showError(bundle, '');
        updateBundle(bundle);
        return;
      }
      var add = event.target.closest('[data-aspyr-bundle-add]');
      if (add && bundle.contains(add)) addBundle(bundle);
    });
    updateBundle(bundle);
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-aspyr-bundle]'), initBundle);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-aspyr-quantity-bundle]'), initQuantityBundle);
  }

  function parseJsonValue(value, fallback) {
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  function normalized(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function variantValues(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (value) { return value != null; });
  }

  function findBundleOfferVariant(bundle, originalVariant) {
    var offer = bundle._aspyrOfferProduct;
    if (!offer || !Array.isArray(offer.variants) || !originalVariant) return null;

    var selected = variantValues(originalVariant);
    var originalNames = bundle._aspyrOriginalOptionNames || [];
    var selectedByName = {};
    originalNames.forEach(function (name, index) { selectedByName[normalized(name)] = selected[index]; });

    var offerNames = (offer.options || []).map(function (option) {
      return typeof option === 'string' ? option : option.name;
    });

    return offer.variants.find(function (variant) {
      var values = variantValues(variant);
      return offerNames.length === values.length && offerNames.every(function (name, index) {
        return selectedByName[normalized(name)] != null && normalized(selectedByName[normalized(name)]) === normalized(values[index]);
      });
    }) || offer.variants.find(function (variant) {
      var values = variantValues(variant);
      return values.length === selected.length && values.every(function (value, index) {
        return normalized(value) === normalized(selected[index]);
      });
    }) || offer.variants.find(function (variant) {
      return normalized(variant.title) === normalized(originalVariant.title);
    }) || (offer.variants.length === 1 ? offer.variants[0] : null);
  }

  function updateQuantityBundlePrices(bundle) {
    var basePrice = Number(bundle.dataset.basePrice || 0);
    var comparePrice = Number(bundle.dataset.comparePrice || 0);

    Array.prototype.forEach.call(bundle.querySelectorAll('[data-aspyr-bundle-tier]'), function (tier) {
      var quantity = Math.max(1, Number(tier.dataset.quantity || 1));
      var extraDiscount = Math.max(0, Math.min(40, Number(tier.dataset.extraDiscount || 0)));
      var discountType = tier.dataset.discountType === 'amount' ? 'amount' : 'percent';
      var regularUnit = comparePrice > basePrice ? comparePrice : basePrice;
      var regularTotal = regularUnit * quantity;
      var priceBeforeDiscount = basePrice * quantity;
      var selectedExtras = bundle._aspyrSelections ? bundle._aspyrSelections.slice(0, quantity - 1) : [];
      if (tier.classList.contains('is-selected') && selectedExtras.length === quantity - 1 && selectedExtras.every(Boolean)) {
        regularTotal = regularUnit + selectedExtras.reduce(function (sum, selection) {
          return sum + Math.max(Number(selection.comparePrice || 0), Number(selection.price || 0));
        }, 0);
        priceBeforeDiscount = basePrice + selectedExtras.reduce(function (sum, selection) {
          return sum + Number(selection.price || 0);
        }, 0);
      }
      var bundleTotal = discountType === 'amount'
        ? Math.max(0, priceBeforeDiscount - Math.round(extraDiscount * 100 * quantity))
        : Math.round(priceBeforeDiscount * (100 - extraDiscount) / 100);
      var saved = Math.max(0, regularTotal - bundleTotal);
      var effectivePercent = regularTotal > 0 ? Math.round(saved * 100 / regularTotal) : 0;
      var price = tier.querySelector('[data-tier-price]');
      var compare = tier.querySelector('[data-tier-compare]');
      var save = tier.querySelector('[data-tier-save]');

      if (price) price.textContent = formatMoney(bundleTotal);
      if (compare) {
        compare.textContent = saved > 0 ? formatMoney(regularTotal) : '';
        compare.hidden = saved <= 0;
      }
      if (save) {
        save.textContent = saved > 0 ? 'SAVE ' + effectivePercent + '%' : '';
        save.hidden = saved <= 0;
      }
    });

    updateQuantityBundleAddButton(bundle);
  }

  function updateQuantityBundleAddButton(bundle) {
    var button = bundle.querySelector('[data-aspyr-bundle-add]');
    if (!button) return;

    var required = requiredBundleSelections(bundle);
    var missing = firstMissingBundleSlot(bundle);
    var tier = bundle.querySelector('[data-aspyr-bundle-tier].is-selected');
    var label = button.querySelector('[data-aspyr-bundle-add-label]');
    var packLabel = tier && tier.dataset.packLabel ? tier.dataset.packLabel : 'BUNDLE';
    var price = tier && tier.querySelector('[data-tier-price]');

    button.hidden = required === 0 || missing > -1;
    button.disabled = required === 0 || missing > -1;
    if (label) {
      label.textContent = 'ADD ' + packLabel + ' TO CART' + (price && price.textContent ? ' · ' + price.textContent : '');
    }
  }

  function selectQuantityTier(bundle, tier) {
    Array.prototype.forEach.call(bundle.querySelectorAll('[data-aspyr-bundle-tier]'), function (candidate) {
      var selected = candidate === tier;
      candidate.classList.toggle('is-selected', selected);
      candidate.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    var name = bundle.querySelector('[data-aspyr-bundle-name]');
    if (name) name.value = (tier.dataset.packLabel || '3-PACK') + ' BUNDLE';
    bundle._aspyrTargetQuantity = Math.max(1, Number(tier.dataset.quantity || 1));
    renderQuantityBundleSelections(bundle);
    updateQuantityBundlePrices(bundle);
  }

  function requiredBundleSelections(bundle) {
    return Math.max(0, Number(bundle._aspyrTargetQuantity || 1) - 1);
  }

  function firstMissingBundleSlot(bundle) {
    var required = requiredBundleSelections(bundle);
    for (var index = 0; index < required; index += 1) {
      if (!bundle._aspyrSelections[index]) return index;
    }
    return -1;
  }

  function showQuantityBundleError(bundle, message) {
    var error = bundle.querySelector('[data-aspyr-quantity-bundle-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function renderQuantityBundleSelections(bundle) {
    var required = requiredBundleSelections(bundle);
    var itemLabel = bundle.dataset.bundleItemLabel || 'item';
    var selections = bundle.querySelector('[data-aspyr-bundle-selections]');
    var selectedTier = bundle.querySelector('[data-aspyr-bundle-tier].is-selected');
    if (selections) {
      selections.hidden = false;
      if (selectedTier && selectedTier.nextElementSibling !== selections) {
        selectedTier.insertAdjacentElement('afterend', selections);
      }
    }

    Array.prototype.forEach.call(bundle.querySelectorAll('[data-aspyr-bundle-slot]'), function (slot, index) {
      var isRequired = index < required;
      var selected = bundle._aspyrSelections[index];
      slot.hidden = !isRequired;
      if (!isRequired) return;

      var title = slot.querySelector('[data-selection-title]');
      var detail = slot.querySelector('[data-selection-detail]');
      var image = slot.querySelector('[data-selection-image]');
      var button = slot.querySelector('[data-aspyr-bundle-choose]');

      slot.classList.toggle('is-filled', !!selected);
      if (title) title.textContent = selected
        ? selected.productTitle
        : 'CHOOSE ' + (index === 0 ? 'SECOND ' : 'THIRD ') + itemLabel.toUpperCase();
      if (detail) detail.textContent = selected ? selected.variantTitle : 'STYLE + SIZE';
      if (button) button.textContent = selected ? 'CHANGE' : 'CHOOSE';
      if (image) {
        image.hidden = !selected || !selected.image;
        image.src = selected && selected.image ? selected.image : '';
        image.alt = selected ? selected.productTitle : '';
      }
    });
  }

  function openQuantityBundleDrawer(bundle, slotIndex) {
    var drawer = bundle._aspyrDrawer || bundle.querySelector('[data-aspyr-bundle-drawer]');
    if (!drawer) return;
    bundle._aspyrActiveSlot = Number(slotIndex || 0);
    drawer.hidden = false;
    document.documentElement.classList.add('aspyr-bundle-drawer-open');
    var close = drawer.querySelector('.aspyr-quantity-bundle__close');
    if (close) close.focus();
  }

  function closeQuantityBundleDrawer(bundle) {
    var drawer = bundle._aspyrDrawer || bundle.querySelector('[data-aspyr-bundle-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('aspyr-bundle-drawer-open');
  }

  function chooseBundleProduct(bundle, choice) {
    var select = choice.querySelector('[data-aspyr-bundle-choice-variant]');
    var option = select && select.options[select.selectedIndex];
    if (!option || !option.value) return;

    var image = choice.querySelector('img');
    bundle._aspyrSelections[bundle._aspyrActiveSlot || 0] = {
      variantId: Number(option.value),
      variantTitle: option.textContent.trim(),
      productTitle: choice.dataset.productTitle || '',
      productHandle: choice.dataset.productHandle || '',
      productUrl: choice.dataset.productUrl || '',
      preorder: choice.dataset.preorder === 'true',
      price: Number(option.dataset.price || 0),
      comparePrice: Number(option.dataset.comparePrice || 0),
      image: image ? image.currentSrc || image.src : ''
    };

    showQuantityBundleError(bundle, '');
    renderQuantityBundleSelections(bundle);
    updateQuantityBundlePrices(bundle);
    var missingSlot = firstMissingBundleSlot(bundle);
    if (missingSlot > -1) {
      bundle._aspyrActiveSlot = missingSlot;
    } else {
      closeQuantityBundleDrawer(bundle);
    }
  }

  function bundleCartItems(bundle, primaryVariant, primaryProperties) {
    var missingSlot = firstMissingBundleSlot(bundle);
    if (missingSlot > -1) {
      return { error: 'Choose every ' + (bundle.dataset.bundleItemLabel || 'item') + ' and size before adding this bundle.' };
    }

    var selectedTier = bundle.querySelector('[data-aspyr-bundle-tier].is-selected');
    var packLabel = ((selectedTier || {}).dataset || {}).packLabel || '3-PACK';
    var displayedDiscount = Number(((selectedTier || {}).dataset || {}).extraDiscount || 0);
    var displayedDiscountType = (((selectedTier || {}).dataset || {}).discountType === 'amount') ? 'amount' : 'percent';
    var displayedTotalNode = selectedTier && selectedTier.querySelector('[data-tier-price]');
    var common = {
      '_aspyr_bundle_id': bundle.dataset.bundleId || 'aspyr-product-pack',
      '_aspyr_bundle_name': packLabel + ' BUNDLE',
      '_Aspyr displayed bundle discount': displayedDiscountType === 'amount'
        ? formatMoney(displayedDiscount * 100) + ' per item'
        : displayedDiscount + '%',
      '_Aspyr displayed bundle total': displayedTotalNode ? displayedTotalNode.textContent.trim() : ''
    };
    var firstProperties = Object.assign({}, primaryProperties || {}, common, { '_aspyr_bundle_component': '1' });
    var items = [{ id: Number(primaryVariant.id), quantity: 1, properties: firstProperties }];
    var preorderMessage = bundle.dataset.preorderMessage || 'ESTIMATED DELIVERY: 45–60 DAYS';

    bundle._aspyrSelections.slice(0, requiredBundleSelections(bundle)).forEach(function (selection, index) {
      var properties = Object.assign({}, common, {
        '_aspyr_bundle_component': String(index + 2),
        '_Original product title': selection.productTitle,
        '_Original product URL': selection.productUrl
      });
      if (selection.preorder) {
        properties['Pre-Order'] = preorderMessage;
        properties['_Preorder'] = 'true';
      }
      items.push({ id: selection.variantId, quantity: 1, properties: properties });
    });

    return { items: items };
  }

  function addStandardBundle(bundle, form, button) {
    var productSelect = form.querySelector('[data-product-select]');
    var variantId = productSelect && Number(productSelect.value);
    if (!variantId) return;
    var payload = bundleCartItems(bundle, { id: variantId }, {});
    if (payload.error) {
      showQuantityBundleError(bundle, payload.error);
      openQuantityBundleDrawer(bundle, firstMissingBundleSlot(bundle));
      return;
    }

    button.disabled = true;
    button.classList.add('btn--loading');
    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: payload.items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status === 422) throw data;
        return data;
      });
    }).then(function (added) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added, addToCartBtn: button } }));
    }).catch(function (error) {
      showQuantityBundleError(bundle, error.description || error.message || 'This bundle could not be added.');
    }).finally(function () {
      button.disabled = false;
      button.classList.remove('btn--loading');
    });
  }

  function initQuantityBundle(bundle) {
    if (bundle.dataset.aspyrQuantityBundleReady === 'true') return;
    bundle.dataset.aspyrQuantityBundleReady = 'true';
    bundle._aspyrSelections = [null, null];
    bundle._aspyrTargetQuantity = 1;
    bundle._aspyrOriginalOptionNames = parseJsonValue(bundle.dataset.originalOptionNames || '[]', []);

    var offerJson = bundle.querySelector('[data-aspyr-quantity-bundle-offer]');
    bundle._aspyrOfferProduct = offerJson ? parseJsonValue(offerJson.textContent, null) : null;

    bundle.addEventListener('click', function (event) {
      var tier = event.target.closest('[data-aspyr-bundle-tier]');
      if (tier && bundle.contains(tier)) {
        selectQuantityTier(bundle, tier);
        return;
      }
      var choose = event.target.closest('[data-aspyr-bundle-choose]');
      if (choose && bundle.contains(choose)) {
        openQuantityBundleDrawer(bundle, Number(choose.dataset.aspyrBundleChoose || 0));
        return;
      }
      var addBundle = event.target.closest('[data-aspyr-bundle-add]');
      if (addBundle && bundle.contains(addBundle) && !addBundle.disabled) {
        var form = bundle.closest('form');
        var purchaseButton = form && (
          form.querySelector('[data-aspyr-preorder-submit]:not([hidden])') ||
          form.querySelector('[data-add-to-cart]:not([hidden])')
        );
        if (purchaseButton && !purchaseButton.disabled) purchaseButton.click();
        return;
      }
    });

    var drawer = bundle.querySelector('[data-aspyr-bundle-drawer]');
    if (drawer) {
      bundle._aspyrDrawer = drawer;
      document.body.appendChild(drawer);
      drawer.addEventListener('click', function (event) {
        var addChoice = event.target.closest('[data-aspyr-bundle-choice-add]');
        if (addChoice && drawer.contains(addChoice)) {
          chooseBundleProduct(bundle, addChoice.closest('[data-aspyr-bundle-choice]'));
          return;
        }
        var close = event.target.closest('[data-aspyr-bundle-close]');
        if (close && drawer.contains(close)) closeQuantityBundleDrawer(bundle);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeQuantityBundleDrawer(bundle);
    });

    var section = bundle.closest('[data-section-type="product"]');
    if (section) {
      section.addEventListener('variantChange', function (event) {
        var originalVariant = event.detail && event.detail.variant;
        var pricedVariant = findBundleOfferVariant(bundle, originalVariant) || originalVariant;
        if (!pricedVariant) return;
        bundle.dataset.basePrice = pricedVariant.price || 0;
        bundle.dataset.comparePrice = pricedVariant.compare_at_price || 0;
        var primarySize = bundle.querySelector('[data-aspyr-bundle-primary-size]');
        var originalValues = variantValues(originalVariant);
        if (primarySize) primarySize.textContent = originalValues.length ? originalValues[originalValues.length - 1] : originalVariant.title;
        updateQuantityBundlePrices(bundle);
      });
    }

    var selected = bundle.querySelector('[data-aspyr-bundle-tier].is-selected') || bundle.querySelector('[data-aspyr-bundle-tier]');
    if (selected) selectQuantityTier(bundle, selected);
    updateQuantityBundlePrices(bundle);

    var form = bundle.closest('form');
    if (form) {
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter || document.activeElement;
        if (requiredBundleSelections(bundle) === 0 || !submitter || !submitter.matches('[data-add-to-cart]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        addStandardBundle(bundle, form, submitter);
      }, true);
    }
  }

  window.AspyrQuantityBundle = {
    buildCartItems: function (form, primaryVariant, primaryProperties) {
      var bundle = form && form.querySelector('[data-aspyr-quantity-bundle]');
      if (!bundle) return null;
      var payload = bundleCartItems(bundle, primaryVariant, primaryProperties);
      if (payload.error) {
        showQuantityBundleError(bundle, payload.error);
        openQuantityBundleDrawer(bundle, firstMissingBundleSlot(bundle));
      }
      return payload;
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) { init(event.target); });
})();
